import { currencyToNumber } from "../currencyToNumber.mjs";
const KOMOJU_METHOD_FEE_PERCENTAGES = {
  komoju_linepay: 3.5,
  komoju_paidy: 9,
  komoju_paypay: 9,
  komoju_aupay: 15,
  komoju_rakutenpay: 8.4,
  komoju_docomo: 15,
  komoju_softbank: 15,
  komoju_au: 15
};
const KOMOJU_CREDIT_CARD_FEE_PERCENTAGES = {
  amex: 3.85,
  diners: 3.85,
  discover: 3.85,
  jcb: 3.85,
  master: 3.6,
  visa: 3.6
};
function getExtendedRevenueEventProperties(opts, config) {
  const { convertCurrency, revenueCurrency } = config;
  let {
    currencyCodeLocal,
    dollarToLocalRate,
    revenueGross,
    revenueGrossLocal
  } = opts;
  const includesUSDRevenue = dollarToLocalRate !== void 0 && revenueGross !== void 0;
  if (!includesUSDRevenue) {
    const usdRevenue = convertCurrency({
      amount: revenueGrossLocal,
      fromCurrency: currencyCodeLocal,
      toCurrency: "USD"
    });
    dollarToLocalRate = usdRevenue == null ? void 0 : usdRevenue.exchangeRate;
    revenueGross = usdRevenue == null ? void 0 : usdRevenue.result;
  }
  const projectCurrencyRevenue = revenueCurrency ? convertCurrency({
    amount: revenueGrossLocal,
    fromCurrency: currencyCodeLocal,
    toCurrency: revenueCurrency
  }) : void 0;
  let currencyCodeSource;
  let sourceToLocalRate;
  if (projectCurrencyRevenue) {
    currencyCodeSource = currencyCodeLocal;
    currencyCodeLocal = revenueCurrency;
    revenueGrossLocal = projectCurrencyRevenue.result;
    sourceToLocalRate = projectCurrencyRevenue.exchangeRate;
  }
  let processorFee = opts.processorFee;
  if (!processorFee) {
    if (opts.purchaseProvider === "stripe") {
      processorFee = 0.044 * revenueGross + 0.3;
    } else if (opts.purchaseProvider === "komoju") {
      if (opts.purchaseProviderMethod in KOMOJU_METHOD_FEE_PERCENTAGES) {
        processorFee = KOMOJU_METHOD_FEE_PERCENTAGES[opts.purchaseProviderMethod] * revenueGross / 100;
      } else if (opts.purchaseProviderMethod === "komoju_credit_card" && opts.purchaseProviderCreditCardBrand in KOMOJU_CREDIT_CARD_FEE_PERCENTAGES) {
        processorFee = KOMOJU_CREDIT_CARD_FEE_PERCENTAGES[opts.purchaseProviderCreditCardBrand] * revenueGross / 100;
      }
    } else if (opts.purchaseProvider === "atone") {
      processorFee = 0.039 * revenueGross;
    } else if (opts.purchaseProvider === "xsolla") {
      processorFee = 0.08 * revenueGross;
    } else {
      processorFee = opts.revenueType === "in_app_purchase" ? 0.3 * revenueGross : 0;
    }
  }
  const projectCurrencyProcessorFee = revenueCurrency ? convertCurrency({
    amount: processorFee,
    fromCurrency: "USD",
    toCurrency: revenueCurrency
  }) : void 0;
  const processorFeeLocal = projectCurrencyProcessorFee == null ? void 0 : projectCurrencyProcessorFee.result;
  const revenueNet = revenueGross - (processorFee ?? 0);
  const projectCurrencyRevenueNet = revenueCurrency ? convertCurrency({
    amount: revenueNet,
    fromCurrency: "USD",
    toCurrency: revenueCurrency
  }) : void 0;
  const revenueNetLocal = projectCurrencyRevenueNet == null ? void 0 : projectCurrencyRevenueNet.result;
  return {
    currencyCodeLocal,
    currencyCodeSource,
    dollarToLocalRate,
    processorFee,
    processorFeeLocal,
    processorFeePercent: processorFee / revenueGross * 100,
    purchaseProvider: opts.purchaseProvider,
    purchaseProviderMethod: opts.purchaseProviderMethod,
    revenueGross,
    revenueGrossLocal,
    revenueNet,
    revenueNetLocal,
    sourceToLocalRate
  };
}
function getExtendedPurchaseEventProperties(product, opts, config) {
  return getExtendedRevenueEventProperties(
    {
      currencyCodeLocal: product.currencyCode,
      purchaseProvider: opts.purchaseProvider,
      purchaseProviderMethod: opts.purchaseProviderMethod,
      revenueGrossLocal: currencyToNumber(product.price),
      revenueType: "in_app_purchase"
    },
    config
  );
}
export {
  getExtendedPurchaseEventProperties,
  getExtendedRevenueEventProperties
};
